import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./utils/theme";
import { GlobalStateProvider } from "./utils/globalState";
import { Auth0Provider } from "@auth0/auth0-react";

export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      redirectUri={window.location.origin}
    >
      <GlobalStateProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </GlobalStateProvider>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
